module.exports = __webpack_public_path__ + "static/img/AIDAN-SCHUBERT.ee10049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AIDAN-SCHUBERT.jpg
// module id = ng1z
// module chunks = 0